// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_6lK","cls2":"CiterightLanding-cls2_ifY CiterightLanding-cls1_6lK"};